import { activateInlineScripts } from '@otto-ec/global-resources/dom';
import { renderPdpRecommendations } from '@otto-ec/nexus-registry/reco/cinemas';
import { getGlobalEventMergeIdIfVariationChanged } from '../../_common/client/tracking';
import { BaseComponent } from '../../base-component';

export class RecoAlternativeComponent extends BaseComponent {
    public rootSelector = '.js_pdp_reco-alternative';
    private isInitialPageLoad = true;

    public async init(): Promise<void> {
        o_global.eventQBus.on('pattern.carousel.init', (carouselSelector: string) => {
            if (document.querySelector(`${this.rootSelector} ${carouselSelector}`)) {
                if (this.getRootElement().classList.contains('pl_hidden')) {
                    this.trackView({ product_HideReco: 'true' });
                }
            }
        });
    }

    public async onHtmlLoaded(): Promise<void> {
        await this.loadReco();
    }

    private async loadReco() {
        if (!this.isPresent()) {
            return;
        }
        const variationId = this.getRootElement().dataset.variationId;
        if (!variationId) {
            return;
        }

        const eventMergeId = getGlobalEventMergeIdIfVariationChanged();
        const rootElement = this.getRootElement();

        if (!this.isInitialPageLoad) {
            await activateInlineScripts(rootElement);
        }
        renderPdpRecommendations({
            variationId,
            eventMergeId,
            target: 'alternative',
        });

        this.isInitialPageLoad = false;
    }
}
